/**
 * FERP Portal - Queue Type Configuration
 *
 * Centralized UI configuration for queue types and statuses.
 * The frontend is DUMB - it only provides UI styling for backend-defined values.
 *
 * Source of truth: backend GraphQL schema
 * Generated types: generated/graphql.ts
 */

import {
  IconList,
  IconFlame,
  IconSkull,
  IconCalendarTime,
  IconArrowsExchange,
} from '@tabler/icons-react';

export const QUEUE_TYPE_UI_CONFIG = {
  TASK: { color: 'blue', icon: IconList, label: 'Task Queue' },
  PRIORITY: { color: 'orange', icon: IconFlame, label: 'Priority Queue' },
  DEAD_LETTER: { color: 'red', icon: IconSkull, label: 'Dead Letter Queue' },
  SCHEDULED: { color: 'violet', icon: IconCalendarTime, label: 'Scheduled Queue' },
  SAGA: { color: 'cyan', icon: IconArrowsExchange, label: 'Saga Queue' },
} as const;

export const QUEUE_STATUS_UI_CONFIG = {
  ACTIVE: { color: 'green', label: 'Active' },
  PAUSED: { color: 'yellow', label: 'Paused' },
  DRAINING: { color: 'orange', label: 'Draining' },
  STOPPED: { color: 'red', label: 'Stopped' },
} as const;

export type QueueType = keyof typeof QUEUE_TYPE_UI_CONFIG;
export type QueueStatus = keyof typeof QUEUE_STATUS_UI_CONFIG;
